import React, { useEffect } from "react";

function Redirect(props) {
    useEffect(() => {
        window.location.replace(props.href);
    }, [props.href]);

    return null;
}

export default Redirect;
